<template>
     
<div :src="business.image" >
      <header class="w3-container w3-theme-d2 w3-hide-small">
          <h3>{{business.name}}</h3>
      </header>
      <div class="w3-row">
        <div class="w3-half " style="padding:10px;text-align:center">
          <img :src="business.image" class="businessimage"/>
        </div>
        <div class="w3-half" style="padding:10px;text-align:center">
          <business-info-layout :business="business"/> 
          <p>
          <open-gooogle-maps :latitude="business.latitude" :longitude="business.longitude"/>
          </p>
        </div>
      </div>
      <footer class="w3-small" style="padding:10px" v-if="business.pwa"><b>{{business.pwa.homeabout}}</b></footer>

</div>
    
</template>
<script>
export default {      
  props:["business"],
  data: function() {
    return {
       
    };
  },
  methods: {}
};
</script>

<style>
  .businessimage{
    height: auto;
    max-width:350px;
  }
</style>
 


// WEBPACK FOOTER //
// src/components/home/BusinessImageBasicTile.vue